<template>
	<div class="card">
		<div class="card-body py-5 text-center text-secondary">
			<h1 class="text-nowrap" style="font-size: 64px">403</h1>
			<h1 class="fw-normal" style="font-size: 16px" v-if="$route.params.halaman">
				Anda tidak memiliki hak akses ke halaman <code class="bg-warning bg-opacity-25 p-1">{{ $route.params.halaman }}</code>
			</h1>
			<h1 class="fw-normal" style="font-size: 16px" v-else>Akses tidak diizinkan</h1>
		</div>
	</div>
</template>

<script>
export default {
	name: "ForbiddenView",
};
</script>

<style scoped></style>
